
export const Home = '/';
export const Support = '/support';
export const Login = '/login';
export const ReceiptDelivery = '/receiptDelivery';
export const Page404 = '/404';

export const ListBooking = '/listbooking';
export const Booking = '/booking'
// export const UpdateBooking = '/updatebooking'
export const DetailBooking = '/detailbooking'
export const ChooseVehicleDriver = '/choosebooking'


export const ListCustomer = '/listcustomer'
export const Customer = '/customer'
export const IMPORTCUSTOMER = '/importcustomer'

export const ListVehicle = '/listvehicle'
export const Vehicle = '/vehicle'

export const ListStoreUser= '/liststoreuser'
export const StoreUser= '/storeuser'


export const ListUser= '/listuser';
export const User = '/user'

export const ListData= '/listdata'
export const Data= '/data'
export const DataOrder= '/dataorder'
export const UpdateCustomerOrder= '/updateorder'
export const AddData= '/adddata'
export const AddDataOrder= '/adddataorder'
export const ImportInvoiceList= '/addlistinvoice'

export const ListStore = '/liststore';
export const Store = '/store';

export const Report = '/report';


export const ListProduct = '/listproduct';
export const Product = '/product';

export const ListStoreProductPrice = '/liststoreproductprice';
export const StoreProductPrice = '/storeproductprice';

export const ListGift = '/listgift';
export const Gift = '/gift';
export const ListSocialAccept = '/listsocialaccept';

export const ReportViewPlanStock = '/reportplanstock';
export const ReportViewSumary1 = '/reportsumary1';
export const ReportViewSumary2 = '/reportsumary2';
export const ReportViewSumary3 = '/reportsumary3';



export const ListSocial = '/listsocial';
export const Social = '/social';
export const SocialClone = '/socialclone';
export const ListCustomerGift = '/listcustomergift';

export const Dashboard = '/dashboard';
export const AssignGift = '/assign-gift';

export const ListGroupStore = '/group-store';
export const ListStorev2 = '/list-store';
export const ListUserv2= '/list-user';
export const ListCustomerv2= '/list-customer';
export const ListFollower= '/list-follower';
export const ListSocialv2 = '/list-social';
export const ListBillAccept = '/list-bill-accept';
export const BlackList = '/black-list';
export const ListReport = '/list-report';
export const ReportCode = '/report-code';
export const ReportTurn = '/report-turn';
export const ChangeProduct = '/change-product';
export const SetProduct = '/set-product';
export const ListPriority = '/list-priority';
export const ListProductMessage = '/list-product-message';
export const ListBillMarket = '/list-bill-market';
export const SetProductTai = '/set-tai';
export const DetailBillAccept= '/detailbill';
export const BlackListZalo = '/black-list-zalo';

export const Lucky = '/lucky';
export const ResetLucky = '/reset-lucky';
export const FinishLucky = '/finish-lucky';